/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Injectable, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/platform-browser";
var ScrollingService = (function () {
    function ScrollingService(_document) {
        this._document = _document;
    }
    ScrollingService.prototype.stopScrolling = function () {
        this._document.body.classList.add("no-scrolling");
    };
    ScrollingService.prototype.resumeScrolling = function () {
        if (this._document.body.classList.contains("no-scrolling")) {
            this._document.body.classList.remove("no-scrolling");
        }
    };
    return ScrollingService;
}());
export { ScrollingService };
ScrollingService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
ScrollingService.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] },] },
]; };
//# sourceMappingURL=scrolling-service.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/utils/scrolling/scrolling-service.js
// module id = 216
// module chunks = 4